import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const BannerCard = styled(Flex)`
    width: 980px;
    margin: 40px;
    padding: 24px;
    border-radius: 8px;
    background-color: ${colorsPalettes.carbon[0]};
    ${setElevation("Z1")}
`;

export const BannerIllustration = styled.img`
    align-self: center;
    height: 190px;
    width: 190px;
`;
